import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { isNewWatchlist } from '../../pages/MyContent/WatchlistsTab/WatchlistsTab.logic';
import { IssuerListDto } from '../../services/dtos/issuer/issuerList.dto';
import { IssuersQueryParams } from '../../services/issuers/issuersQueryParams';
import { fetchIssuers } from '../../services/issuers/issuers.service';
import { queryKeys } from '../queryKeyFactory';

export default (
  queryParams: IssuersQueryParams,
  options?: UseQueryOptions<IssuerListDto, Error>
): UseQueryResult<IssuerListDto, Error> => {
  return useQuery<IssuerListDto, Error>(
    queryKeys.fetchIssuers.query(queryParams),
    async () => {
      if (queryParams.watchlistId && isNewWatchlist(queryParams.watchlistId)) {
        return { results: [], totalResults: 0 };
      }

      return fetchIssuers(queryParams);
    },
    options
  );
};
